import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './gaia.css';
import './gaia-bootstrap.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Amplify, Auth } from 'aws-amplify';
import config from './config';
import { LoadingProvider } from './contexts/common/LoadingContext';
import { AuthProvider } from './contexts/common/AuthContext';
import SceneRouter from './SceneRouter';
import LoadingModal from './components/organisms/LoadingModal/LoadingModal';
import FooterPanel from './features/Footer/FooterPanel';
import CookieDisclaimer from './features/CookieDisclaimer/CookieDisclaimer';
import { SSOProvider } from './contexts/common/SSOContext';
import { CustomersProvider } from './contexts/Customer/CustomersContext';
import { CustomerAccountsProvider } from './contexts/Customer/CustomerAccountsContext';
import { CookiesProvider } from 'react-cookie';
import { UserProvider } from './contexts/Auth/UserContext';
import { AlertProvider } from './contexts/common/AlertContext';
import { MenuProvider } from './contexts/MenuContext/MenuContext';
import { CookieProvider } from './contexts/Cookies/CookieContext';
import ScaniaHeader from './features/MenuNavbar/ScaniaHeader';
import { defineCustomElements } from '@scania/tegel-react';
import ScaniaSideMenu from './features/MenuNavbar/ScaniaSideMenu';
import { ProvidersFilterContextProvider } from './contexts/FilterContexts/ProvidersFilterContext';
import { AccountsFilterContextProvider } from './contexts/FilterContexts/AccountsFilterContext';
import { ServicesFilterContextProvider } from './contexts/FilterContexts/ServicesFilterContext';
import { CategoriesFilterContextProvider } from './contexts/FilterContexts/CategoriesFilterContext';
import { DateFilterContextProvider } from './contexts/FilterContexts/DateFilterContext';
import { CompanyTotalsProvider } from './contexts/CompanyTotalsContext/CompanyTotalsContext';
import { EmissionsProvider } from './contexts/Emissions/EmissionsContext';

defineCustomElements();

const root = ReactDOM.createRoot(document.getElementById('root'));
const getToken = async () => {
  // Get demo token from API if DEMO environment (TODO: Investigate if token must be refreshed from time to time or not..)
  if (config.ENVIRONMENT === 'DEMO') {
    let response = await fetch(config.API_GATEWAY_AUTH_URL + '/v1/demo/token', {
      headers: {
        Host: config.HOSTNAME
      },
      mode: 'cors',
      method: 'GET'
    });
    let data = await response.json();
    return data['Token'];
  }

  // Use normal authentication flow if not DEMO environment
  return (await Auth.currentSession()).idToken.jwtToken;
};

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.REGION,
    userPoolId: config.COGNITO_USER_POOL,
    userPoolWebClientId: config.COGNITO_APP_CLIENT_ID,
    oauth: {
      domain: config.OAUTH_DOMAIN,
      scope: ['email', 'profile', 'openid'],
      redirectSignIn: config.OAUTH_REDIRECT_SIGN_IN,
      redirectSignOut: config.OAUTH_REDIRECT_SIGN_OUT,
      responseType: 'code',
      options: {
        // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
        AdvancedSecurityDataCollectionFlag: false
      }
    }
  },
  API: {
    endpoints: [
      {
        name: 'auth',
        endpoint: config.API_GATEWAY_AUTH_URL,
        region: config.REGION,
        custom_header: async () => {
          return {
            Authorization: await getToken()
          };
        }
      },
      {
        name: 'idp',
        endpoint: config.API_GATEWAY_AUTH_URL,
        region: config.REGION
      },
      {
        name: 'emissions',
        endpoint: config.API_GATEWAY_EMISSIONS_URL,
        region: config.REGION,
        custom_header: async () => {
          return {
            Authorization: await getToken()
          };
        }
      },
      {
        name: 'customer',
        endpoint: config.API_GATEWAY_CUSTOMER_URL,
        region: config.REGION,
        custom_header: async () => {
          return {
            Authorization: await getToken()
          };
        }
      }
    ]
  }
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CookiesProvider>
        <AlertProvider>
          <AuthProvider>
            <SSOProvider>
              <UserProvider>
                <CookieProvider>
                  <LoadingProvider>
                    <CustomersProvider>
                      <MenuProvider>
                        <LoadingModal />
                        <ScaniaHeader />
                        <ScaniaSideMenu>
                          <CustomerAccountsProvider>
                            <ProvidersFilterContextProvider>
                              <AccountsFilterContextProvider>
                                <ServicesFilterContextProvider>
                                  <CategoriesFilterContextProvider>
                                    <DateFilterContextProvider>
                                      <CompanyTotalsProvider>
                                        <EmissionsProvider>
                                          <SceneRouter></SceneRouter>
                                        </EmissionsProvider>
                                      </CompanyTotalsProvider>
                                    </DateFilterContextProvider>
                                  </CategoriesFilterContextProvider>
                                </ServicesFilterContextProvider>
                              </AccountsFilterContextProvider>
                            </ProvidersFilterContextProvider>
                          </CustomerAccountsProvider>
                        </ScaniaSideMenu>
                        <FooterPanel />
                        <CookieDisclaimer />
                      </MenuProvider>
                    </CustomersProvider>
                  </LoadingProvider>
                </CookieProvider>
              </UserProvider>
            </SSOProvider>
          </AuthProvider>
        </AlertProvider>
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
